"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const settings_1 = require("../settings");
const executor_1 = require("../executor");
class BaseClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        this.settings = settings;
        this.executor = settings.executor || new executor_1.HttpExecutor(settings);
    }
    httpGet(path, opts) {
        return this.executeCall('get', path, null, opts);
    }
    httpPut(path, data, opts) {
        return this.executeCall('put', path, data, opts);
    }
    httpPost(path, data, opts) {
        return this.executeCall('post', path, data, opts);
    }
    httpDelete(path, data, opts) {
        return this.executeCall('delete', path, data, opts);
    }
    httpPatch(path, data, opts) {
        return this.executeCall('patch', path, data, opts);
    }
    executeRaw(method, path, data, opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.executor.executeRaw(method, path, data, opts);
        });
    }
    executeCall(method, path, data, opts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.executor.executeCall(method, path, data, opts);
        });
    }
    getQueryString(params) {
        return Object.entries(params)
            .filter(([_, value]) => value !== undefined && value !== null)
            .reduce((query, [key, value]) => query + `${key}=${this.encodeValue(value)}&`, '');
    }
    encodeValue(value) {
        if (value instanceof Date) {
            const date = value.toISOString();
            return encodeURIComponent(date);
        }
        if (value instanceof Array) {
            return value.map((i) => this.encodeValue(i)).join(',');
        }
        if ((0, lodash_1.isObject)(value)) {
            return this.encodeObject(value);
        }
        return encodeURIComponent(value);
    }
    encodeObject(obj) {
        const cleanedObject = Object.keys(obj).reduce((acc, key) => {
            return obj[key] ? Object.assign(Object.assign({}, acc), { [key]: obj[key] }) : acc;
        }, {});
        return encodeURIComponent(JSON.stringify(cleanedObject));
    }
}
exports.BaseClient = BaseClient;
//# sourceMappingURL=base.client.js.map